
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"fill-current",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16.17.46l3.18 3.19c.2.2.2.5 0 .7l-3.18 3.19a.5.5 0 11-.7-.71l2.32-2.33h-.19v-1h.2l-2.34-2.33a.5.5 0 11.71-.7zM.5 3.5h1.9v1H.5v-1zm3.6 0h2.8v1H4.1v-1zm4.5 0h2.8v1H8.6v-1zm4.5 0h2.8v1h-2.8v-1z","fill":"#F9C22E"}})])
          )
        }
      }
    